import { FS } from '../enums/FeatureSwitch';

export default class FeatureSwitchService {

	static map(featureSwitches) {
		const fsObj = {};
		const feFsArr = Object.values(FS);

		featureSwitches.forEach((fs) => {
			if (fs.active && feFsArr.includes(fs.name)) {
				fsObj[fs.name] = fs.raffles;
			}
		});

		return fsObj;
	}

	static has(fsState, fs, raffle = null) {
		const featureSwitches = fsState.values;

		return !!featureSwitches[fs] && (featureSwitches[fs].length === 0 || (raffle ? featureSwitches[fs].includes(raffle) : false));
	}
}


// WEBPACK FOOTER //
// ./services/FeatureSwitchService.js